const quickLinks = {
  de: [
    {
      name: "ULTIMATECUT",
      url: "/de/ultimatecut/ultimatecut",
    },
    {
      name: "Anwendungstipps",
      url: "/de/wissen/how-to",
    },
    {
      name: "Produkterklärungen",
      url: "/de/wissen/know-how/",
    },
    {
      name: "Karriere",
      url: "/de/unternehmen/karriere",
    },
  ],
  en: [
    {
      name: "ULTIMATECUT",
      url: "/en/ultimatecut/ultimatecut",
    },
    {
      name: "Application tips",
      url: "/en/knowledge/how-to/",
    },
    {
      name: "Product explanations",
      url: "/en/knowledge/know-how/",
    },
  ],
  fr: [
    {
      name: "ULTIMATECUT",
      url: "/fr/ultimatecut/ultimatecut",
    },
    {
      name: "Conseils d'application",
      url: "/fr/connaissances/how-to",
    },
    {
      name: "Déclarations de produits",
      url: "/fr/connaissances/know-how",
    },
  ],
  dk: [
    {
      name: "ULTIMATECUT",
      url: "/dk/ultimatecut/ultimatecut",
    },
    {
      name: "Tips til ansøgning",
      url: "/dk/viden/how-to",
    },
    {
      name: "Produktforklaringer",
      url: "/dk/viden/know-how",
    },
  ],
  es: [
    {
      name: "ULTIMATECUT",
      url: "/es/ultimatecut/ultimatecut",
    },
    {
      name: "Consejos de aplicación",
      url: "/es/conocimiento/how-to",
    },
    {
      name: "Explicaciones del producto",
      url: "/es/conocimiento/know-how",
    },
  ],
}

module.exports = {
  quickLinks: quickLinks,
}
